/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataItemFromJSON, MetaDataItemToJSON, } from './';
export function MetaDataFromJSON(json) {
    return MetaDataFromJSONTyped(json, false);
}
export function MetaDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'items': !exists(json, 'items') ? undefined : (json['items'].map(MetaDataItemFromJSON)),
        'responseId': !exists(json, 'responseId') ? undefined : json['responseId']
    };
}
export function MetaDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'items': value.items === undefined ? undefined : (value.items.map(MetaDataItemToJSON)),
        'responseId': value.responseId
    };
}
